import React from 'react';

import Header from "../components/site/header.js";
import Footer from "../components/site/footer.js";
import MovieFilters from "../components/movie/moviesfilters.js";
import Loader from "../components/site/loader.js";

import { library } from '@fortawesome/fontawesome-svg-core';
import { faTimes, faSearch} from '@fortawesome/free-solid-svg-icons';
library.add(faTimes,faSearch);

export default function Search() {

    return (
    <section >
        <Header />
        <MovieFilters />
        <Footer />
        <Loader />
    </section>
    )
}


         